import script from "./DeleteIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteIcon.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteIcon.vue?vue&type=style&index=0&id=0e9b7522&lang=css"

const __exports__ = script;

export default __exports__